import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Link } from "react-router-dom";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";

export default function FAQSection() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/faqs").then(r => setItems(r.data)); }, []);
  if (!items.length) return null;

  return (
    <section className="py-20 md:py-28 bg-[hsl(var(--muted))]/40" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <div className="text-xs md:text-sm uppercase tracking-[0.2em] text-[color:var(--brand-sky)] font-semibold mb-3">
          FAQ
        </div>
        <h2 className="font-display text-3xl md:text-5xl font-bold text-[color:var(--brand-navy)] mb-10 leading-tight">
          Vos questions,<br/>nos réponses claires.
        </h2>
        <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
          {items.map((q) => (
            <AccordionItem key={q.id} value={q.id} className="bg-white rounded-2xl border border-[hsl(var(--border))] px-5 shadow-soft">
              <AccordionTrigger className="py-5 text-left font-display font-semibold text-base md:text-lg text-[color:var(--brand-navy)] hover:no-underline">
                {q.question}
              </AccordionTrigger>
              <AccordionContent className="pb-5 text-[hsl(var(--muted-foreground))] text-sm md:text-base leading-relaxed">
                {q.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
        <div className="mt-10 text-center">
          <Link to="/contact" className="text-sm font-semibold text-[color:var(--brand-navy)] hover:text-[color:var(--brand-sky)]">
            Vous avez une autre question ? Contactez-nous →
          </Link>
        </div>
      </div>
    </section>
  );
}
